import React from 'react';

// Components
import { injectStripe, CardElement } from 'react-stripe-elements';
import injectSheet from 'react-jss';

const styles = theme => {
  return {
    root: {
      marginTop: theme.spacing.unit * 2,
      padding: theme.spacing.unit,
      background: theme.palette.common.gray,
    },
  };
};

interface Props {
  classes: any;
  stripe: any;
}

function CardInput({ classes, stripe }: Props) {
  return stripe ? (
    <div className={classes.root}>
      <CardElement style={{ base: { fontSize: '18px', fontFamily: 'Work Sans, geneva' } }} />
    </div>
  ) : null;
}

export default injectStripe(injectSheet(styles)(CardInput));
